<app-cargando *ngIf="cargando || cargandoCodigos" [mensaje]="loadingMessage"></app-cargando>

<div class="venta-page">
<div class="row">
  <div class="col-12">
    <div class="card venta-card">
      <div class="card-header">
        <h3 class="card-title">{{ titulo }} {{ data.DocNum }}</h3>
      </div>
      <div class="card-body">
        <!-- BANNER DE RESCATE TRANSBANK ANTI-PÁNICO -->
        <div *ngIf="cobroRescate && (!pagoIntent || !hasTarjetas)" class="alert alert-warning d-flex justify-content-between align-items-center mb-3 shadow-sm border-warning" role="alert" style="border-left: 5px solid #ffc107; background-color: #fffdf5;">
          <div>
            <i class="fas fa-shield-alt text-warning fa-lg me-2"></i>
            <strong>¡Cobro pendiente por asociar!</strong> Se detectó un cobro con tarjeta Transbank por 
            <strong>{{ cobroRescate.totalPayment | iNDCLP }}</strong> 
            (Voucher <strong>#{{ cobroRescate.authorizationCode }}</strong>, {{ cobroRescate.cardType }} ****{{ cobroRescate.last4Digits }}) 
            en el terminal <em>{{ cobroRescate.terminalNombre || cobroRescate.terminalId }}</em>.
            <div class="small text-muted mt-1">
              Si se cerró la pantalla o falló SAP, no vuelvas a cobrar al cliente. Haz clic en vincular para asociar este pago a la venta.
            </div>
          </div>
          <div class="d-flex align-items-center" style="gap: 8px;">
            <button type="button" class="btn btn-sm btn-primary" (click)="recuperarCobroPendiente()">
              <i class="fas fa-link me-1"></i> Vincular a esta venta
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="descartarCobroPendiente()">
              Descartar
            </button>
          </div>
        </div>
        <div *ngIf="data.ObjType == '13'" class="alert alert-info d-flex justify-content-between align-items-center" role="alert">
          <div>
            <i class="fas fa-link me-2"></i>
            <span *ngIf="baseNVEntry; else sinBase">NV base seleccionada: DocEntry {{baseNVEntry}}<span *ngIf="baseNVDocNum"> (N° {{baseNVDocNum}})</span></span>
            <ng-template #sinBase>
              <span>No hay NV base seleccionada.</span>
            </ng-template>
          </div>
          <button class="btn btn-sm btn-primary" (click)="seleccionarOrdenVentaBase()" title="Seleccionar Nota de Venta base">
            <i class="fas fa-exchange-alt" style="margin-right:6px;"></i>
            Seleccionar NV
          </button>
        </div>
        <div class="row">
          <div class="form-group col-md-4" style="padding-left: 0px !important;">
            <div class="col-md-12">
              <label for="txtCardCode">{{ nombreCampo("CardCode") }}</label>
            </div>
            <div class="col-md-12">
              <div class="input-group input-group-sm" style="width: 100%">
                
                <input id="CardCode" type="text" class="form-control" [(ngModel)]="data.CardCode" disabled="" />
                <span class="input-group-append">
                  <button type="button" class="btn btn-info btn-flat" (click)="selecionarCliente()">
                    <i class="fas fa-search"></i>
                  </button>
                </span>

                <span class="input-group-append" *ngIf="data.CardCode">
                  <button type="button" class="btn btn-info btn-flat" (click)="seleccionarDocHisto()">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 8V12L14.5 14.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M5.60423 5.60423L5.0739 5.0739V5.0739L5.60423 5.60423ZM4.33785 6.87061L3.58786 6.87438C3.58992 7.28564 3.92281 7.61853 4.33408 7.6206L4.33785 6.87061ZM6.87963 7.63339C7.29384 7.63547 7.63131 7.30138 7.63339 6.88717C7.63547 6.47296 7.30138 6.13549 6.88717 6.13341L6.87963 7.63339ZM5.07505 4.32129C5.07296 3.90708 4.7355 3.57298 4.32129 3.57506C3.90708 3.57715 3.57298 3.91462 3.57507 4.32882L5.07505 4.32129ZM3.75 12C3.75 11.5858 3.41421 11.25 3 11.25C2.58579 11.25 2.25 11.5858 2.25 12H3.75ZM16.8755 20.4452C17.2341 20.2378 17.3566 19.779 17.1492 19.4204C16.9418 19.0619 16.483 18.9393 16.1245 19.1468L16.8755 20.4452ZM19.1468 16.1245C18.9393 16.483 19.0619 16.9418 19.4204 17.1492C19.779 17.3566 20.2378 17.2341 20.4452 16.8755L19.1468 16.1245ZM5.14033 5.07126C4.84598 5.36269 4.84361 5.83756 5.13505 6.13191C5.42648 6.42626 5.90134 6.42862 6.19569 6.13719L5.14033 5.07126ZM18.8623 5.13786C15.0421 1.31766 8.86882 1.27898 5.0739 5.0739L6.13456 6.13456C9.33366 2.93545 14.5572 2.95404 17.8017 6.19852L18.8623 5.13786ZM5.0739 5.0739L3.80752 6.34028L4.86818 7.40094L6.13456 6.13456L5.0739 5.0739ZM4.33408 7.6206L6.87963 7.63339L6.88717 6.13341L4.34162 6.12062L4.33408 7.6206ZM5.08784 6.86684L5.07505 4.32129L3.57507 4.32882L3.58786 6.87438L5.08784 6.86684ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM16.1245 19.1468C14.9118 19.8483 13.5039 20.25 12 20.25V21.75C13.7747 21.75 15.4407 21.2752 16.8755 20.4452L16.1245 19.1468ZM20.25 12C20.25 13.5039 19.8483 14.9118 19.1468 16.1245L20.4452 16.8755C21.2752 15.4407 21.75 13.7747 21.75 12H20.25ZM6.19569 6.13719C7.68707 4.66059 9.73646 3.75 12 3.75V2.25C9.32542 2.25 6.90113 3.32791 5.14033 5.07126L6.19569 6.13719Z" fill="#ffffff"></path> </g></svg>                    
                  </button>
                </span>

                <span class="input-group-append">
                  <button type="button" class="btn btn-info btn-flat" (click)="CargarDatosClienteCuentas()">
                    <i class="fas fa-folder"></i>
                  </button>
                </span>
              </div>
              <input id="CardName" type="text" class="form-control mt-1" [(ngModel)]="data.CardName" placeholder="Nombre del cliente" />
            </div>
          </div>

          <div class="form-group col-md-4">
            <div class="col-md-12">
              <label for="Moneda">Moneda</label>
            </div>

            <div class="col-md-12">
              <select class="form-control" [(ngModel)]="data.Currency" name="Currency" (change)="cambioTipoMoneda(true)"
                [disabled]="!data.ListaCUrrency">
                <option *ngFor="let curre of OCRN" [ngValue]="curre.CurrCode">
                  {{ curre.CurrName }}
                </option>
              </select>
              <div style="display: flex" *ngIf="peruApi">
                <input type="number" [(ngModel)]="tipoCambio" style="
                    background: #343a40;
                    color: white;
                    border: 1px solid grey;
                    width: -webkit-fill-available;" />
              </div>

              <label *ngIf="data.Currency != 'CLP' && !peruApi">{{
                tipoCambio | currency : data.Currency
                }}</label>
              <label *ngIf="data.Currency == 'CLP' && !peruApi">{{
                tipoCambio | iNDCLP
                }}</label>
            </div>
          </div>
          <div class="form-group col-md-4">
            <div class="col-md-3">
              <label> Impuesto </label>
            </div>
            <div class="col-md-12">
              <select id="TAXCODE" class="form-control" [(ngModel)]="TaxCode" (change)="UpdateTaxCode()">
                <option *ngFor="let row of IMPUESTOS" [value]="row.Code">
                  {{ row.Name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Dirección de despacho -->
          <div class="form-group col-md-4">
            <label>{{ nombreCampo("ShipToDef") }}</label>
            <div class="field-inline">
              <select class="form-control" [(ngModel)]="data.ShipToDef" name="ShipToDef"
                      (change)="cargaDatosDireccionDespacho($event.target.value)" [disabled]="!data.CardCode">
                <option [ngValue]="null" disabled>Selecciona dirección</option>
                <option *ngFor="let row of DESPACHO" [value]="row.Address">{{ row.Address }}</option>
              </select>
              <button class="btn btn-warning btn-icon" (click)="abreDireccion('DESPACHO')" [disabled]="!data.CardCode" title="Editar direcciones">
                <i class="fas fa-ellipsis-h fa-xs"></i>
              </button>
            </div>
            <div class="address-preview" *ngIf="data.Address">{{ data.Address }}</div>
          </div>
          <!-- Dirección factura -->
          <div class="form-group col-md-4">
            <label>{{ nombreCampo("BillToDef") }}</label>
            <div class="field-inline">
              <select class="form-control" [(ngModel)]="data.BillToDef" name="BillToDef" [disabled]="!data.CardCode">
                <option [ngValue]="null" disabled>Selecciona dirección</option>
                <option *ngFor="let row of FACTURA" [ngValue]="row.Address">{{ row.Address }}</option>
              </select>
            </div>
            <div class="address-preview" *ngIf="textoDirFactura()">{{ textoDirFactura() }}</div>
          </div>
          <!-- Condición de pago -->
            <div class="form-group col-md-4">
              <label>{{ nombreCampo("GroupNum") }}</label>
              <div class="field-inline">
                <select class="form-control" [(ngModel)]="data.GroupNum" name="GroupNum" *ngIf="peruApi">
                  <option [ngValue]="null" disabled>Selecciona condicion de pago</option>
                  <option *ngFor="let row of OCTG" [ngValue]="row.GroupNum">{{ row.PymntGroup }}</option>
                </select>
                <select class="form-control" [(ngModel)]="data.GroupNum" name="GroupNum" *ngIf="!peruApi" [disabled]="true">
                  <option [ngValue]="null" disabled>Selecciona condicion de pago</option>
                  <option *ngFor="let row of OCTG" [ngValue]="row.GroupNum">{{ row.PymntGroup }}</option>
                </select>
              </div>
            </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label>{{ nombreCampo("TrnspCode") }}</label>
            <select class="form-control" [(ngModel)]="data.TrnspCode" name="TrnspCode" [disabled]="!data.CardCode">
              <option [ngValue]="null" disabled>Seleccione una opción</option>
              <option *ngFor="let row of OSHP" [ngValue]="row.TrnspCode">
                {{ row.TrnspName }}
              </option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label> OC y otros documentos </label>
            <div class="col-12" style="display: flex">
              <input type="text" class="form-control" [(ngModel)]="data.NumAtCard" />

              <div style="display: flex;">

                <a class="btn btn-primary" href="javascript:;" style="position: relative;cursor: pointer;">
                  <i class="fa-solid fa-paperclip"></i>
                  <input type="file"
                    style="width: 100%; height: 100%; position: absolute; opacity: 0;top: 0px;left: 0px;"
                    (change)="onFileSelected($event)">
                </a>


                <a class="btn btn-primary" href="javascript:;" data-toggle="modal" data-target="#ModalAdjuntos"
                  *ngIf="Archivos.length > 0">
                  <i class="fa-solid fa-eye"></i>
                </a>
              </div>

            </div>
          </div>


        </div>

        <div class="row">
          <div class="col-12">
            <label>
              <h4>{{ nombreCampo("DocumentDetails") }}</h4>
            </label>
            <button class="btn btn-primary" (click)="addLine()" [disabled]="!data.CardCode">
              <i class="far fa-plus-square"></i>
            </button>

            <div class="d-flex flex-wrap align-items-center mt-2" style="gap:8px;">
              <div class="input-group input-group-sm" style="width:300px;">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="background:#1f2937;border-color:#1f2937;color:#fff;">
                    <i class="fas fa-barcode"></i>
                  </span>
                </div>
                <input #manualScanInput
                       type="text"
                       class="form-control"
                       autocomplete="off"
                       spellcheck="false"
                       inputmode="text"
                       placeholder="Escanear / ingresar código de barras o artículo (ej: 7896541234567|2)"
                       [(ngModel)]="scanManualCode"
                       (keydown)="onManualKeydown($event)"
                       [disabled]="cargandoCodigos"
                       aria-label="Escanear o ingresar código del artículo" />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="openScanner(true)" [disabled]="cargandoCodigos" title="Escanear con cámara">
                    <i class="fas fa-camera"></i>
                  </button>
                </div>
              </div>
              <small class="text-muted" *ngIf="cargandoCodigos">
                <i class="fas fa-spinner fa-spin me-1"></i>
                Cargando códigos, por favor espere...
              </small>
              <!-- Fallback capture input (oculto) -->
              <input #fallbackCapture type="file" accept="image/*" capture="environment" (change)="onFallbackCaptureChange($event)" style="display:none" />
            </div>

            <div class="input-group-prepend float-right">
              <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-expanded="false"
                [disabled]="!data.CardCode"></button>
              <ul class="dropdown-menu">
                <li class="dropdown-item" *ngFor="let row of columnsCopy">
                  <input type="checkbox" [checked]="validaColumnaValidaInicio(row.key)"
                    (change)="ocultaColumna(row.key)" [disabled]="row.disabled" />{{ row.title }}
                </li>
              </ul>
            </div>

            <hr />
          </div>
          <div class="columns col-12">
            <ngx-table #table [configuration]="configuration" [data]="data.Detalles" [columns]="columns"
              (event)="eventEmitted($event)"></ngx-table>

            <ng-template #frmItemCode let-row let-rowIndex="rowIndex">
              <div class="input-group input-group-sm" style="width: 200px">
                <input type="text" class="form-control form-control-sm" [value]="row.ItemCode" disabled />
                <span class="input-group-append">
                  <button type="button" class="btn btn-info btn-flat btn-sm" (click)="ListaMateriales(row, rowIndex)">
                    <i class="fas fa-search"></i>
                  </button>
                </span>
              </div>
            </ng-template>

            <ng-template #frmFrgnName let-row let-rowIndex="rowIndex">
              <div class="input-group input-group-sm" style="width: 200px">
                <input type="text" class="form-control form-control-sm" [value]="row.FrgnName" disabled />

              </div>
            </ng-template>

            <ng-template #frmCodTransworld let-row let-rowIndex="rowIndex">
              <div *ngFor="let item of listaCodigoTransworld">
                <div *ngIf="row.ItemCode == item.ItemCode">
                  <label>{{item.U_IND_SWW}}</label>
                </div>
              </div>

            </ng-template>

            <ng-template #frmDscription let-row let-rowIndex="rowIndex">
              <div class="input-group input-group-sm" style="width: 300px">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="row.Dscription" />
              </div>
            </ng-template>

            <ng-template #frmFactor1 let-row let-rowIndex="rowIndex">
              <input style="width: 100px" type="number" class="form-control form-control-sm" [(ngModel)]="row.Factor1"
                name="Factor1" (blur)="cambiaDatoLinea(row, rowIndex, 'FACTOR1')" />
            </ng-template>

            <ng-template #frmFactor2 let-row let-rowIndex="rowIndex">
              {{ row.Factor2 }}
            </ng-template>

            <ng-template #frmQuantity let-row let-rowIndex="rowIndex">
              <input [id]="'qty-' + rowIndex" style="width: 80px" type="number" step="1" class="form-control form-control-sm"
                [(ngModel)]="row.Quantity" name="Quantity" (blur)="cambiaDatoLinea(row, rowIndex, 'CANTIDAD')" />
            </ng-template>

            <ng-template #frmWhsCode let-row let-rowIndex="rowIndex">
              <select class="form-control form-control-sm" [(ngModel)]="row.WhsCode" name="WhsCode"
                [disabled]="!BodegaEditable" (blur)="cambiaDatoLinea(row, rowIndex, 'CANTIDAD')" style="width: 150px">
                <option [ngValue]="null" disabled>Selecciona Bodega</option>
                <option *ngFor="let row of OWHS" [ngValue]="row.WhsCode">
                  {{ row.WhsName }}
                </option>
              </select>
            </ng-template>

            <ng-template #frmPrice let-row let-rowIndex="rowIndex">

              <ng-container *ngIf="this.data.ObjType == '23' || this.data.ObjType == '17'">
                <div *ngFor="let item of row.UserFields">

                  <div *ngIf="item.Field == 'U_IND_TIPO' && (item.Value == 'Liquidacion' || item.Value == 'Oferta')">

                    <input style="width: 80px" type="number" step="1" class="form-control form-control-sm"
                      [(ngModel)]="row.Price" name="Price" (blur)="cambiaDatoLinea(row, rowIndex, 'PRECIO')"/>

                  </div>

                  <div *ngIf="item.Field == 'U_IND_TIPO' && !(item.Value == 'Liquidacion' || item.Value == 'Oferta')">

                    <input style="width: 80px" type="number" step="1" class="form-control form-control-sm"
                      [(ngModel)]="row.Price" name="Price" (blur)="cambiaDatoLinea(row, rowIndex, 'PRECIO')" ß />

                  </div>


                </div>
              </ng-container>

              <ng-container *ngIf="!(this.data.ObjType == '23' || this.data.ObjType == '17')">
                <div>
                  <input style="width: 80px" type="number" step="1" class="form-control form-control-sm"
                    [(ngModel)]="row.Price" name="Price" (blur)="cambiaDatoLinea(row, rowIndex, 'PRECIO')" ß />
                </div>
              </ng-container>



            </ng-template>

            <ng-template #frmDisc let-row let-rowIndex="rowIndex">

                    <input style="width: 80px" type="number" step="0.1" class="form-control form-control-sm"
                      [(ngModel)]="row.Disc" name="Disc" (blur)="cambiaDatoLinea(row, rowIndex, 'DESCUENTO')" />
              
            </ng-template>

            <ng-template #frmPriceAfeterDisc let-row let-rowIndex="rowIndex">

              <ng-container *ngIf="(this.data.ObjType == '23' || this.data.ObjType == '17')">
                <div *ngFor="let item of row.UserFields">
                  <div *ngIf="
                      item.Field == 'U_IND_TIPO' &&
                      (item.Value == 'Liquidacion' || item.Value == 'Oferta') &&
                      (this.data.ObjType == '23' || this.data.ObjType == '17')
                    " (click)="liquidacion()">
                    <input style="width: 80px" type="number" step="1" class="form-control form-control-sm"
                      [(ngModel)]="row.PriceAfeterDisc" name="PriceAfeterDisc"
                      (blur)="cambiaDatoLinea(row, rowIndex, 'PriceAfeterDisc')" disabled />
                  </div>
  
                  <div *ngIf="
                      item.Field == 'U_IND_TIPO' &&
                      !(item.Value == 'Liquidacion' || item.Value == 'Oferta') &&
                      (this.data.ObjType == '23' || this.data.ObjType == '17')
                    ">
                    <input style="width: 80px" type="number" step="1" class="form-control form-control-sm"
                      [(ngModel)]="row.PriceAfeterDisc" name="PriceAfeterDisc"
                      (blur)="cambiaDatoLinea(row, rowIndex, 'PriceAfeterDisc')" disabled/>
                  </div>
                  
                </div>
              </ng-container>
              
              <ng-container *ngIf="!(this.data.ObjType == '23' || this.data.ObjType == '17')">
                <div>
                    <input style="width: 80px" type="number" step="1" class="form-control form-control-sm"
                      [(ngModel)]="row.PriceAfeterDisc" name="PriceAfeterDisc"
                      (blur)="cambiaDatoLinea(row, rowIndex, 'PriceAfeterDisc')" />
                  </div>
              </ng-container>
              
            </ng-template>

            <ng-template #frmEstadoWMS let-row let-rowIndex="rowIndex">
              <div *ngFor="let item of row.UserFields">
                <select *ngIf="item.Field == 'U_IND_WMS_ESTADO'" [(ngModel)]="item.Value">
                  <option value="N">No enviar WMS</option>
                  <option value="T">Enviar WMS</option>
                  <option value="Y">Enviado WMS</option>
                </select>
              </div>
            </ng-template>

            <ng-template #frmTaxCode let-row let-rowIndex="rowIndex">
              <select class="form-control form-control-sm" style="width: 120px" [(ngModel)]="row.TaxCode" (change)="VatSum()">
                <option *ngFor="let imp of IMPUESTOS" [value]="imp.Code">{{ imp.Name || imp.Code }}</option>
              </select>
            </ng-template>

            <ng-template #frmLineTotal let-row let-rowIndex="rowIndex">
              <div *ngIf="data.Currency != 'CLP'">
                {{ row.LineTotal | currency : row.Currency }}
              </div>
              <div *ngIf="data.Currency == 'CLP'">
                {{ row.LineTotal | iNDCLP }}
              </div>
            </ng-template>

            <ng-template #frmShipDate let-row let-rowIndex="rowIndex">
              <input class="form-control" type="date" [(ngModel)]="row.ShipDate">
            </ng-template>

            <ng-template #frmAccion let-row let-rowIndex="rowIndex">
              <button type="button" class="btn btn-warning btn-sm" (click)="abrirLoteSerie(row)"
                *ngIf="data.ManBtchNum == 'N'" disabled>
                <i class="fas fa-dolly"></i>
              </button>
              <button type="button" class="btn btn-info btn-sm" (click)="abrirLoteSerie(row)"
                [hidden]="data.ManBtchNum == 'N'">
                <i class="fas fa-dolly"></i>
              </button>
              <button type="button" class="btn btn-success btn-sm" (click)="abrirItemDetalle(row)" [hidden]="HidePur()">
                <i class="fas fa-list"></i>
              </button>
              <button type="button" class="btn btn-danger btn-sm" (click)="removeRow(rowIndex)">
                <i class="fas fa-trash-alt"></i>
              </button>
            </ng-template>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-4 col-sm-6">
            <div class="col-md-8">
              <label *ngIf="data.ObjType != '234000031'">{{ nombreCampo("DocDueDate") }}</label>
              <label *ngIf="data.ObjType == '234000031'"> Fecha Solicitud Devolución</label>
              <input *ngIf="data.ObjType != '234000031'" type="date" [(ngModel)]="data.DocDueDate"
                [ngModel]="data.DocDueDate | date : 'yyyy-MM-dd'" datetime="yyyy-MM-dd HH:mm:ss" name="DocDueDate"
                class="form-control" TextMode="date" [disabled]="!data.CardCode" />
              <div *ngIf="data.ObjType == '234000031'" style="padding-bottom: 10px;font-size: 17px;">
                {{data.DocDueDate | date:'dd/MM/yyyy'}}
              </div>
            </div>
            <div class="form-group col-md-8">
              <label>{{ nombreCampo("SlpCode") }}</label>
              <br />

              <select class="form-control" [(ngModel)]="data.SlpCode" name="SlpCode" [disabled]="!data.CardCode">
                <option [ngValue]="null" disabled>Selecciona vendedor</option>
                <option *ngFor="let vendedor of OSLP" [ngValue]="vendedor.SlpCode">
                  {{ vendedor.SlpName }}
                </option>
              </select>
            </div>

            <ng-container *ngFor="let item of data.UserFields">
              <ng-container *ngIf="item.Field == 'U_IND_EstadosNV' && data.ObjType == '17'">
                
                <div class="form-group col-md-8">
                  <label>Estado NV</label>
                  <br />
    
                  <select class="form-control" [(ngModel)]="item.Value" name="SlpCode" [disabled]="!data.CardCode">
                    <option [ngValue]="null" disabled>Seleccione Estado</option>
                    <option value="1">Recibido</option>
                    <option value="2">En preparación</option>
                    <option value="3">Preparado</option>
                  </select>
                </div>

              </ng-container>
            </ng-container>

            <div class="form-group col-md-8" [hidden]="true">
              <label>Propietario</label>
              <select class="form-control" [(ngModel)]="data.OwnerCode" name="OwnerCode" [disabled]="!data.CardCode">
                <option [ngValue]="null" disabled>
                  Selecciona propietario
                </option>
                <option *ngFor="let emp of OHEM" [ngValue]="emp.empID">
                  {{ emp.lastName }} {{ emp.firstName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-xs-4 col-sm-6">
            <div class="col-md-12">
              <label>Total Antes del impuesto</label>
              <div class="row">
                <div class="col-md-8">
                  <input class="form-control text-right" value="{{ GrossProfit() | currency : data.Currency }}"
                    *ngIf="data.Currency != 'CLP'" disabled />
                  <input class="form-control text-right" value="{{ GrossProfit() | iNDCLP }}"
                    *ngIf="data.Currency == 'CLP'" disabled />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <label>Descuento </label>
              <div class="row">
                <div class="col-md-2">
                  <input type="number" step="1" class="form-control text-left" name="DiscPrcnt" [value]="data.DiscPrcnt"
                    (change)="cambiaInput($event)" />
                </div>

                <div class="col-md-6">
                  <input class="form-control text-right" value="{{ DiscTotal() | currency : data.Currency }}"
                    *ngIf="data.Currency != 'CLP'" disabled />
                  <input class="form-control text-right" value="{{ DiscTotal() | iNDCLP }}"
                    *ngIf="data.Currency == 'CLP'" disabled />
                </div>
              </div>
            </div>

            <div class="col-md-12" *ngIf="TaxCode === 'ILA' && !peruApi; else singleTaxBlock">
              <label>Impuesto {{ TaxName }}</label>
              <div class="row">
                <div class="col-md-8">
                  <input class="form-control text-right" value="{{ PrimaryTaxSum() | currency : data.Currency }}"
                    *ngIf="data.Currency != 'CLP'" disabled />
                  <input class="form-control text-right" value="{{ PrimaryTaxSum() | iNDCLP }}" *ngIf="data.Currency == 'CLP'"
                    disabled />
                </div>
              </div>
              <label class="mt-2">Impuesto IVA</label>
              <div class="row">
                <div class="col-md-8">
                  <input class="form-control text-right" value="{{ ExtraIvaSum() | currency : data.Currency }}"
                    *ngIf="data.Currency != 'CLP'" disabled />
                  <input class="form-control text-right" value="{{ ExtraIvaSum() | iNDCLP }}" *ngIf="data.Currency == 'CLP'"
                    disabled />
                </div>
              </div>
            </div>
            <ng-template #singleTaxBlock>
              <div class="col-md-12">
                <label *ngIf="!peruApi">Impuesto {{ TaxName || '' }}</label>
                <label *ngIf="peruApi">Impuesto IGV</label>
                <div class="row">
                  <div class="col-md-8">
                    <input class="form-control text-right" value="{{ VatSum() | currency : data.Currency }}"
                      *ngIf="data.Currency != 'CLP'" disabled />
                    <input class="form-control text-right" value="{{ VatSum() | iNDCLP }}" *ngIf="data.Currency == 'CLP'"
                      disabled />
                  </div>
                </div>
              </div>
            </ng-template>
            <div class="col-md-12" *ngIf="data.RoundDifFC && data.RoundDifFC !== 0">
              <label>Redondeo</label>
              <div class="row">
                <div class="col-md-8">
                  <input class="form-control text-right font-weight-bold" value="{{ data.RoundDifFC | iNDCLP }}" disabled />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <label>Monto Total</label>
              <div class="row">
                <div class="col-md-8">
                  <input class="form-control text-right" value="{{ DocTotal() | currency : data.Currency }}"
                    *ngIf="data.Currency != 'CLP'" disabled />
                  <input class="form-control text-right" value="{{ DocTotal() | iNDCLP }}"
                    *ngIf="data.Currency == 'CLP'" disabled />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div *ngFor="let row of data.UserFields">
              <div class="row">
                <div class="col-md-12" *ngIf="row.Field == 'U_IND_COMENTARIO_FACTURA'">
                  <label>Comentario vendedor a Bodega</label>
                  <textarea [(ngModel)]="row.Value" id="txtComments" type="text" class="form-control"
                    TextMode="MultiLine" style="height: 100px; width: 100%"></textarea>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div *ngFor="let row of data.UserFields">
              <div class="row">
                <div class="col-md-12" *ngIf="row.Field == 'U_IND_COMENTARIO_PEDIDO'">
                  <label>Comentario de vendedor a facturación</label>
                  <textarea [(ngModel)]="row.Value" id="txtComments" type="text" class="form-control"
                    TextMode="MultiLine" style="height: 100px; width: 100%"></textarea>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <label>Comentario a Bodega</label>
            <textarea id="txtComments" type="text" class="form-control" TextMode="MultiLine"
              style="height: 100px; width: 100%" [(ngModel)]="data.Comments"></textarea>
            <br />
          </div>

          <!-- Sección de Pago (nueva ubicación al final, versión destacada) -->
          <div class="col-md-12">
            <div class="payment-block" [ngClass]="{'has-payment': !!pagoIntent}">
              <div class="header">
                <i class="fas fa-credit-card" style="color:#00b894;"></i>
                <div class="title">Pagos</div>
                <div class="badge-opcional" *ngIf="!pagoIntent">Opcional</div>
              </div>
              <div class="body" *ngIf="!pagoIntent">
                Registra un pago antes de crear el documento; se adjuntará automáticamente al generarlo.
              </div>
              <ng-container *ngIf="pagoIntent">
                <div class="breakdown">
                  <div class="method" *ngIf="hasTransferencia">
                    <div class="title">Transferencia</div>
                    <div>{{ transferenciaAmmount | iNDCLP }}</div>
                  </div>
                  <div class="method" *ngIf="hasEfectivo">
                    <div class="title">Efectivo</div>
                    <div>{{ efectivoAmmount | iNDCLP }}</div>
                  </div>
                  <div class="method" *ngIf="hasCheques">
                    <div class="title">Cheques</div>
                    <div>{{ totalCheques | iNDCLP }} <span *ngIf="pagoIntent?.cheque?.length">({{pagoIntent?.cheque?.length}})</span></div>
                  </div>
                  <div class="method" *ngIf="hasTarjetas">
                    <div class="title">Tarjetas</div>
                    <div>{{ totalTarjetas | iNDCLP }} <span *ngIf="pagoIntent?.tarjetaCredito?.length">({{pagoIntent?.tarjetaCredito?.length}})</span></div>
                  </div>
                </div>
                <div class="total-line">Total pago preparado: <strong>{{ pagoPreviewTotal | iNDCLP }}</strong></div>
                <div class="action-edit">
                  <button (click)="editarPago()"><i class="fas fa-pen me-1"></i>Editar</button>
                  <button class="danger" (click)="limpiarPago()"><i class="fas fa-times me-1"></i>Quitar</button>
                </div>
              </ng-container>
            </div>
            <div class="separator-above-create"></div>
          </div>

          <!-- Botones externos (Agregar/Editar Pago + Crear Documento) -->
          <div class="col-md-12">
            <div class="dual-actions below-payment">
              <button *ngIf="!pagoIntent" class="button-main split" (click)="abrirModalPago()" [disabled]="!data.CardCode || data.DocEntry>0">
                <i class="fas fa-plus-circle me-1"></i>Agregar pago
              </button>
              <button *ngIf="pagoIntent" class="button-main split" (click)="editarPago()" [disabled]="!data.CardCode || data.DocEntry>0">
                <i class="fas fa-pen me-1"></i>Editar pago
              </button>
              <ng-container>
                <button type="button" class="btn btn-success btn-create-doc split" (click)="generarDocumento()"
                        [disabled]="!data.CardCode"
                        *ngIf='!(data.ObjType == "23" || data.ObjType == "17") && data?.DocEntry == -1'>
                  {{ creaActualiza }} {{ titulo }}
                </button>
                <button type="button" class="btn btn-success btn-create-doc split" (click)="agregarOportunidad()"
                        [disabled]="!data.CardCode"
                        *ngIf='(data.ObjType == "23" || data.ObjType == "17") && data?.DocEntry < 0'>
                  {{ creaActualiza }} {{ titulo }}
                </button>
                <button type="button" class="btn btn-success btn-create-doc split" (click)="generarDocumento()"
                        [disabled]="!data.CardCode" *ngIf="data?.DocEntry > 0">
                  {{ creaActualiza }} {{ titulo }}
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="ModalAdjuntos" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Adjuntos</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table style="width: 100%;">
          <thead>
            <tr>
              <th>NOMBRE</th>
              <th>VER</th>
              <th>ELIMINAR</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Archivos">
              <td>{{item.FileName}}</td>
              <td>
                <button (click)="verAdjunto(item)">
                  <i class="fa-solid fa-eye"></i>
                </button>
              </td>
              <td>
                <button (click)="eliminaAdjunto(item)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>

<!-- Scanner modal RELOCATED outside of any Bootstrap .modal container to avoid being hidden by display:none -->
<div class="scanner-backdrop" *ngIf="showScanner" (click)="closeScanner()"></div>
<div class="scanner-modal" *ngIf="showScanner" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
  <button class="scanner-close-floating" (click)="closeScanner()" aria-label="Cerrar">&times;</button>
  <div class="scanner-header">
    <div>
      <i class="fas fa-barcode"></i>
      <span *ngIf="!singleScan">Escanear artículos (modo batch)</span>
      <span *ngIf="singleScan">Escanear código (único)</span>
    </div>
    <button class="btn btn-sm btn-outline-light" (click)="closeScanner()"><i class="fas fa-times"></i></button>
  </div>
  <div class="scanner-body">
    <div class="video-wrap">
      <video #scannerVideo autoplay playsinline muted></video>
      <div *ngIf="!scannerVideoRef?.nativeElement" class="scanner-hint"><i class="fas fa-info-circle"></i> Inicializando cámara...</div>
      <div class="scan-frame"><span class="scan-line"></span></div>
      <div class="scanner-hint" *ngIf="scannerError"><i class="fas fa-info-circle"></i> {{scannerError}}</div>
      <div class="scanner-hint" *ngIf="!scannerError && singleScan"><i class="fas fa-info-circle"></i> Apunta al código; se cerrará automáticamente.</div>
    </div>
    <div class="text-muted small mt-2" *ngIf="!singleScan">Códigos acumulados: {{ bufferCount() }}</div>
  </div>
  <div class="scanner-footer" *ngIf="!singleScan">
    <button class="btn btn-success btn-sm" (click)="commitScannedLines()" [disabled]="bufferCount()===0">Agregar líneas</button>
    <button class="btn btn-secondary btn-sm" (click)="clearBuffer()" [disabled]="bufferCount()===0">Limpiar</button>
  </div>
  </div>
</div>